<template>
  <div class="drawer-box">
    <h1 class="title" v-html="details.title"></h1>
    <div class="release-box">
      <div>发布时间：{{ $global.transferDate(details.createTime) }}</div>
      <!-- <div>创建人：{{details.createUser}}</div> -->
      <div>创建人：{{ details.perName }}</div>
    </div>
    <div class="column">
      <span class="line"></span>
      <span style="vertical-align: middle">基本信息</span>
    </div>
    <div class="drawer-content">
      <div class="item">
        <span class="label">关键词：</span>
        <span class="content">{{ details.keywords }}</span>
      </div>
      <div class="item" v-if="details.summary">
        <span class="label">摘要：</span>
        <span class="content" v-html="details.summary"></span>
      </div>
      <div class="item">
        <span class="label">正文：</span>
        <span class="content" v-html="details.content"></span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["id"],
  created() {
    this.getEcho(this.id);
  },
  data() {
    return {
      details: {},
    };
  },
  methods: {
    // 获取详情
    async getEcho(id) {
      const resp = await this.$apis.userServe.getLetter({ id });
      this.details = resp.data;
    },
  },
};
</script>

<style lang="scss" scoped>
.drawer-box {
  padding: 0 20px 20px;
  .title {
    font-size: 26px;
    font-weight: 400;
    color: #333333;
    line-height: 48px;
  }
  .release-box {
    margin: 10px 0 48px;
    display: flex;
    justify-content: space-between;
    font-size: 14px;
    color: #333333;
  }
  .column {
    display: flex;
    align-items: center;
    font-size: 18px;
    color: #3c3c3c;
    .line {
      margin-right: 14px;
      width: 4px;
      height: 16px;
      background: #4343c1;
    }
  }
  .drawer-content {
    margin-top: 25px;
    .item {
      display: flex;
      .label {
        margin-right: 15px;
        width: 60px;
        font-size: 14px;
        font-weight: bold;
        color: #333333;
        line-height: 30px;
      }
      .content {
        flex: 1;
        font-size: 14px;
        color: #000000;
        line-height: 30px;
        &::v-deep img, 
        &::v-deep video{
          max-width: 100% !important;
        }
        &::v-deep p{
          max-width: 605px !important;
        }
        &::v-deep span {
          white-space: normal !important;
        }
      }
    }
  }
}
</style>